/**
 * nk-cart.js
 * Cart countdown timer for purchase_right expiration (Epic 8).
 * Expiration enforcement is server-owned; never send a browser clock as an
 * authorization input.
 */
(function(){
  "use strict";

  /* ===== Countdown timer ===== */
  var countdownEl = document.getElementById("nk-cart-countdown");
  if (countdownEl) {
    var timerEl = document.getElementById("nk-cart-timer");
    if (timerEl) {
      var raw = countdownEl.getAttribute("data-nk-purchase-right");
      if (raw) {
        var pr;
        try { pr = JSON.parse(raw); } catch(e) { pr = null; }
        var rights = Array.isArray(pr) ? pr : (pr ? [pr] : []);
        rights = rights.filter(function(right){ return right && right.expires_at; });
        var cartProductsRaw = countdownEl.getAttribute("data-nk-cart-products");
        if (cartProductsRaw) {
          try {
            var cartProducts = JSON.parse(cartProductsRaw);
            if (Array.isArray(cartProducts) && cartProducts.length) {
              rights = rights.filter(function(right){
                return cartProducts.indexOf(right.drop_id) !== -1;
              });
            }
          } catch (_error) {}
        }
        rights.sort(function(a, b){ return String(a.expires_at).localeCompare(String(b.expires_at)); });
        if (rights.length) {
          var expiresAt = new Date(rights[0].expires_at).getTime();

          var update = function(){
            var now = Date.now();
            var diff = expiresAt - now;

            if (diff <= 0) {
              timerEl.textContent = "EXPIRED / 期限切れ";
              timerEl.style.color = "var(--c2)";
              clearInterval(intervalId);
              return;
            }

            var hours = Math.floor(diff / 3600000);
            var mins = Math.floor((diff % 3600000) / 60000);
            timerEl.textContent = String(hours).padStart(2, "0") + ":" + String(mins).padStart(2, "0");

            // 残り6時間未満で警告色
            if (diff < 6 * 3600000) {
              timerEl.style.color = "var(--c2)";
            } else {
              timerEl.style.color = "var(--c1)";
            }
          };

          update();
          var intervalId = setInterval(update, 60000);
        }
      }
    }
  }
})();
